import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiRecupEvenementsColidee } from "../../../api/ApiColidee";
import { apiGetPersonnes } from "../../../api/ApiPersonnes";
import { apiGetProcesses } from "../../../api/ApiProcess";
import ComponentTitle from "../../layout/ComponentTitle";
import { Link } from "react-router-dom";
import { toDateParseTCompact, toDateCompactFR } from "../../../utils/datesHeures";
import bandeauEvenement from "../../../assets/images/bandeauEvenement.jpg";
import bandeauPersonne from "../../../assets/images/bandeauPersonne.jpg";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";
import { Image } from "react-bootstrap";
import ComponentLoader from "../../layout/ComponentLoader";
import { compareDates, toDateParseFR } from "../../../utils/datesHeures";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";

const BlocEpingle2 = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [datasSortedDateEventEmbauche, setDatasSortedDateEventEmbauche] = useState([]);
  const [focusPrimaire, setFocusPrimaire] = useState();
  const [focusSecondaire, setFocusSecondaire] = useState([]);
  const [loader, setLoader] = useState(false);

  const classementDatePersonnesEvenements = async () => {
    let personnes = [];
    let evenements = [];

    const res = await apiGetPersonnes(
      ReduxInstance._id,
      "include=orgUnitsParent,marque,localisations"
    );
    if (res) {
      personnes = res.data;
    }

    if (ReduxInstance.modulesActives.includes("evenement")) {
      const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
      var listeEspaces = [];
      resProcesses.data.map((process) => (listeEspaces = listeEspaces.concat(process.espaces)));
      listeEspaces = listeEspaces.filter((x, i, a) => a.indexOf(x) === i);

      const form = new FormData();
      form.append("espacesSouhaites", listeEspaces.join(","));

      const resEvenements = await apiRecupEvenementsColidee(ReduxToken, form);
      if (resEvenements.data) {
        evenements = resEvenements.data;
      }
    }

    var classement = [];
    let primaire = "";
    let secondaire = [];
    if (personnes) {
      personnes.forEach((item) => {
        if (item.focusPrimaire || item.focusSecondaire) {
          item.focusPrimaire
            ? (primaire = {
                date: toDateParseTCompact(item.dateEmbauche),
                type: "personne",
                data: item,
              })
            : secondaire.push({
                date: toDateParseTCompact(item.dateEmbauche),
                type: "personne",
                data: item,
              });
        } else {
          classement.push({
            date: toDateParseTCompact(item.dateEmbauche),
            type: "personne",
            data: item,
          });
        }
      });
      setFocusPrimaire(primaire);
      setFocusSecondaire(secondaire);
    }

    if (evenements) {
      evenements.forEach((item) => {
        classement.push({
          date: toDateCompactFR(item.date_evenement),
          type: "evenement",
          data: item,
        });
      });
    }

    classement.sort((b, a) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));

    setDatasSortedDateEventEmbauche(classement);
    setLoader(false);
  };

  const renderItem = (affichage, objet, index) => {
    if (objet.type === "evenement" && ReduxInstance.modulesActives.includes("evenement")) {
      return (
        <a
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "/o" +
            objet.data.id_entreprise +
            "p" +
            objet.data.id_plateforme +
            "/evenements.htm?event=" +
            objet.data.id_evenement
          }
          target="_blank"
          rel="noreferrer"
          key={affichage + "_" + index}
          className="d-flex flex-nowrap  mb-3"
        >
          <div
            className="blocIllustration"
            style={{
              backgroundImage: objet.data.vignette
                ? `url(` + objet.data.vignette + `)`
                : `url(` + process.env.REACT_APP_URL_COLIDEE + "img/medailloneasygouv.png" + `)`,
            }}
          ></div>
          <div className="evenement flex-grow-1">
            <div className="categorieArticles">
              {t("public.pageHome.categorieObjet6")}{" "}
              <span className="float-end">{objet.data.date_evenement}</span>
            </div>
            {objet.data.titre}
            <div className="mt-2 nomPlateforme">{objet.data.nom}</div>
          </div>
        </a>
      );
    }

    if (objet.type === "personne") {
      return (
        <div key={affichage + "_" + index} className="d-flex mb-3">
          <div
            className="blocIllustration blocIllustrationPersonne"
            style={{
              backgroundImage: objet.data.profilePic
                ? `url(` +
                  process.env.REACT_APP_URL_EXPRESS +
                  "images/avatar/small/" +
                  objet.data.profilePic +
                  `)`
                : `url(` + genericAvatar + `)`,
            }}
          ></div>

          <div className="personne flex-grow-1">
            <div className="categorieArticles">
              {t("public.pageHome.categorieObjet7")}
              <div>
                {!compareDates(objet.data.dateEmbauche, Date.now()) &&
                  t("public.pageHome.arriveLe") + toDateParseFR(objet.data.dateEmbauche)}
              </div>
            </div>
            <Link to={"/insocial?name=" + objet.data.nom}>
              <span className="fw-bold">{objet.data.prenom + " " + objet.data.nom}</span>
            </Link>

            <div className="missions">
              {objet.data.orgUnitsParent
                .filter((elem) => elem.type === "Rituel")
                .map((elem, index) => (
                  <React.Fragment key={elem._id + "_" + index}>
                    {elem.orgUnitParent === ReduxInstance.orgunitPrincipalInOperation && (
                      <li>
                        - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                      </li>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (ReduxInstance.modulesActives.includes("accueil2")) {
      setLoader(true);
      classementDatePersonnesEvenements();
    }
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="hackHomeEthicsTransparent">
      {ReduxInstance.modulesActives.includes("accueil2") && (
        <>
          <ComponentTitleAndSousTitle title={t("public.pageHome.titleBloc2")} />
          {loader && <ComponentLoader />}
        </>
      )}
      <br />
      {(datasSortedDateEventEmbauche.length > 0 ||
        focusPrimaire !== "" ||
        focusSecondaire.length > 0) &&
        ReduxInstance.modulesActives.includes("accueil2") && (
          <>
            <div className="containerBlocEpingle">
              {focusPrimaire && <>{renderItem("principal", focusPrimaire, "fp")}</>}
              {!focusPrimaire &&
                datasSortedDateEventEmbauche
                  .slice(0, 1)
                  .map((objet, index) => renderItem("principal", objet, index))}

              <div className="blocSecondaire d-flex justify-content-between  ">
                {focusSecondaire.map((personne, index) =>
                  renderItem("secondaire", personne, "fs_" + index)
                )}

                {datasSortedDateEventEmbauche
                  .slice(
                    focusPrimaire ? 0 : 1,
                    focusPrimaire ? 2 - focusSecondaire.length : 3 - focusSecondaire.length
                  )
                  .map((objet, index) => renderItem("secondaire", objet, index))}
              </div>
            </div>
          </>
        )}
    </div>
  );
};

export default BlocEpingle2;
